import { Grid } from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { UPDATE_FECHA_NACIMIENTO_PACIENTE } from "../../../../data/graphQL/mutations/SoporteHC/paciente";
import { useMutationHandler } from "../../hooks/useMutationHandler";

export default function CambiarFechaNacimientoForm() {
    const inputFields = [
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC Paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
        {
            name: 'fechaNacimiento',
            type: 'date',
            displayName: 'Fecha de nacimiento',
            size: 2,
            required: true,
            placeholder: 'Ingrese fecha',
            disableFuture: true
        },
    ];

    const { values, handleChange, handleSubmit, loading } =
        useMutationHandler({
            initialValues: {
                idPaciente: '',
                fechaNacimiento: '',
            },
            mutation: UPDATE_FECHA_NACIMIENTO_PACIENTE,
            onSuccess: (data) => {
                if (data.updateFechaNacimientoPaciente.error) {
                    toast.error(data.updateFechaNacimientoPaciente.error);
                }

                if (data.updateFechaNacimientoPaciente.success)
                    toast.success('La fecha de nacimiento del paciente se actualizó correctamente.');
            }
        });

    const validAndSubmit = (e) => {
        e.preventDefault();
        let error = '';

        if (!moment(values['fechaNacimiento']).isValid() || moment(values['fechaNacimiento']).isBefore('1499-12-31'))
            error = 'Ingrese una fecha válida';

        if (error) {
            toast.error(error);
            return;
        }
        handleSubmit(e);
    }

    return (
        <form onSubmit={(e) => validAndSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={validAndSubmit}
                    >Aceptar</CustomButton>
                </Grid>
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
